import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BusinessAuthService } from '../services/business-auth.service';

/**
 * Guard para rutas de "invitado" (ej. login).
 * Si ya hay sesión en el área empresas, redirige al panel.
 */
export const businessGuestGuard: CanActivateFn = () => {
  const auth = inject(BusinessAuthService);
  const router = inject(Router);

  if (auth.isLoggedIn()) {
    router.navigateByUrl('/empresas/panel');
    return false;
  }
  return true;
};
